'use strict';

//Utility
import React from 'react';
import autoBind from 'react-autobind';
//Components
import SectionHeader from '../Common/SectionHeader.jsx';
import RadioInput from '../Common/RadioInput.jsx';
import SpecifyBankAccountList from '../Common/SpecifyBankAccountList.jsx';
import BankAccountDetails from '../Common/BankAccountDetails.jsx';
import InlineMessage from '../Common/InlineMessage.jsx';
//Constants
import IncomeDistributionConstants from '../../constants/IncomeDistributionConstants.js';
import ApplicationConstants from '../../constants/ApplicationConstants.js';
//Store
import IncomeDistributionStore from '../../stores/IncomeDistributionStore.js';
//Action
import IncomeDistributionActions from '../../actions/IncomeDistributionActions.js';

let showAddBank = false;

function getStateFromStores() {
    return {
        model: IncomeDistributionStore.getIncomeDistributionModel(),
        bankAccountsList: IncomeDistributionStore.getBankAccountsList(),
        formError: IncomeDistributionStore.getFormError(),
        bankAccountDetailsMsg: IncomeDistributionStore.getBankAccountDetailsMsg(),
        isBankAccountMissing: IncomeDistributionStore.isBankAccountMissing(),
        isManualEntryBankDetailsMissing: IncomeDistributionStore.isManualEntryBankDetailsMissing()
    };
}

export default class IncomeDistributionSection extends React.Component {
    constructor(props) {
        super(props);
        autoBind(this);
        this.state = getStateFromStores();
    }
    componentDidMount() {
        IncomeDistributionStore.addChangeListener(this._onChange);
    }
    componentWillUnmount() {
        IncomeDistributionStore.removeChangeListener(this._onChange);
    }
    _onChange() {
        this.setState(getStateFromStores());
    }
    updateModel(e) {
        IncomeDistributionActions.updateIncomeDistributionModel(e.target.model, e.target.value, e.target.id);
    }
    render () {
        showAddBank = (this.state.model.paymentMethod === IncomeDistributionConstants.bankAccountText);
        return (
           <div>
               <SectionHeader sectionName="Income distribution" focus={this.props.focus} sectionHelpText="Need help?" NeedHelpInfo={this.props.content.incomeDistribution.incomeDistributionHelp} />
               <div className="container">
                   <RadioInput id="idPaymentMethod"
                               label="How would you like your income distributions to be paid?"
                               model="paymentMethod"
                               value={this.state.model.paymentMethod}
                               data={IncomeDistributionConstants.IncomeDistributionRadioData}
                               onChange={this.updateModel} />
                   {showAddBank ?
                        <div>
                        {(this.state.bankAccountsList.length > 1) ?
                           <SpecifyBankAccountList id="idSpecifyBankAccountsList"
                                                   model="selectedBankAccount"
                                                   tableId="idSpecifyBankAccountTable"
                                                   data={this.state.bankAccountsList}
                                                   onChange={this.updateModel}
                                                   checked={this.state.model.selectedBankAccount}
                                                   label="Pay your distributions to:" />
                           : null}

                            {(this.state.bankAccountsList.length === 0 || this.state.model.selectedBankAccount === IncomeDistributionConstants.nominateText) ?
                             <div className="form-section">
                                <div className="form-label-section">
                                    <label>Pay your distributions to:</label>
                                </div>                              
                                    <BankAccountDetails id="idNominateOtherBankAccount"
                                                        section="incomeDistribution"
                                                        data={this.state.model}
                                                        onBlur={this.updateModel}
                                                        errorList={this.state.formError} />
                                    <InlineMessage id="incomeDistributionmanualBankAccountDetails"
                                                   type={ApplicationConstants.messageTypes.error}
                                                   isHidden={!this.state.isManualEntryBankDetailsMissing}
                                                   message={this.props.content.incomeDistribution.bankAccountRequiredMessage} />
                                { (this.state.bankAccountDetailsMsg) ?   
                                     <InlineMessage id="contextualMessageBankAccountDetailsMsg"
                                                    customClass="contextual-message-marginTopMed"
                                                    type={ApplicationConstants.messageTypes.info}
                                                    message={this.props.content.pensionPayment.provideBankDetailsHelpText} />
                                : null}
                             </div> 
                           : null}
                            <InlineMessage id="incomeDistributionbankAccountDetails"
                                           type={ApplicationConstants.messageTypes.error}
                                           isHidden={!this.state.isBankAccountMissing}
                                           message={this.props.content.incomeDistribution.bankAccountRequiredMessage} />
                       </div>                                       
                   : null }
               </div>
           </div>
        );
    }
}


// WEBPACK FOOTER //
// C:/GH/1106/advice.noa.origination/~/eslint-loader!./components/IncomeDistribution/IncomeDistributionSection.jsx